import React from 'react'
import { Routes } from '../../routes'
import { Images } from '../../constants'

interface ChildProps {
    newElement: string
    create: 'process' | 'group'
    noResult: boolean
}

const NewProcessOrGroupV2: React.FC<ChildProps> = ({ newElement, create, noResult }) => {
    const isProcess = create === 'process'
    const backgroundImage = isProcess ? Images.newProcess : Images.folder

    const backgroundStyle: React.CSSProperties = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    }

    return (
        <div className="mt-3">
            {!noResult ? (
                <a
                    href={isProcess ? Routes.PROCESS_CREATE : Routes.CREATE_GROUP_PROCESS}
                    className="text-decoration-none"
                >
                    <div
                        className="card text-center shadow-sm process-card unified-process-default-card border-0 position-relative"
                        style={{
                            ...backgroundStyle,
                            backgroundColor: !backgroundImage ? 'var(--bg-secondary)' : undefined,
                        }}
                        role="button"
                    >
                        <div className="card-body d-flex flex-column justify-content-center align-items-center unified-process-card-overlay rounded h-100">
                            <h5 className="card-title mb-2 unified-process-card-title">
                                <i className="bi bi-plus-circle me-2"></i>
                            </h5>
                            <p className="card-text small unified-process-card-desc mb-0" style={{ height: '43.26px' }}>
                                {newElement}
                            </p>
                        </div>
                    </div>
                </a>
            ) : (
                <div
                    className="card text-center shadow-sm process-card unified-process-default-card border-0 position-relative"
                    style={{
                        backgroundColor: 'var(--bg-secondary)',
                    }}
                >
                    <div className="card-body d-flex flex-column justify-content-center align-items-center unified-process-card-overlay rounded h-100">
                        <h5 className="card-title mb-2 unified-process-card-title">
                            <i className="fa-solid fa-ban me-2"></i>
                        </h5>
                        <p className="card-text small unified-process-card-desc mb-0" style={{ height: '43.26px' }}>
                            {newElement}
                        </p>
                    </div>
                </div>
            )}
        </div>
    )
}

export default NewProcessOrGroupV2
